import { SxProps } from '@mui/material';
import { PrimaryColors } from '@/common/theme/constants';

export const filterCheckboxListContainerStyles = (isLast: boolean): SxProps => ({
  borderBottom: isLast ? 'none' : `1px solid ${PrimaryColors.black}`,
  paddingBottom: '8px',
  marginBottom: '8px',
});

export const filterCheckboxListTitleStyles: SxProps = {
  fontWeight: 'bold',
  textTransform: 'uppercase',
};
